var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "recommend-list" },
    [
      _vm._m(0),
      _c("item-list", {
        attrs: { itemList: _vm.itemList },
        on: { "click-item": _vm.clickItem },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title flex-center" }, [
      _c("div", { staticClass: "img-title" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }